import util from '@bmp-vue/core/api/util'

const controller = 'ParametrizacaoGlobalAgendaRecebiveis'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetCompartilhado: function () {
    return util.Axios.GetAll(controller + '/Limite/Compartilhado')
  },
  PersistCompartilhado: function (dto, options) {
    if (dto && dto.codigo) {
      return util.Axios.Put(controller + '/Limite/Compartilhado', dto.codigo, dto)
    } else {
      return util.Axios.Post(controller + '/Limite/Compartilhado', dto, options)
    }
  },
  GetDuplicata: function () {
    return util.Axios.GetAll(controller + '/Limite/Duplicata')
  },
  PersistDuplicata: function (dto, options) {
    if (dto && dto.codigo) {
      return util.Axios.Put(controller + '/Limite/Duplicata', dto.codigo, dto)
    } else {
      return util.Axios.Post(controller + '/Limite/Duplicata', dto, options)
    }
  },
})
